import { FAQ } from "../actions/action-types";

export const faqReducer = (state = "", action) => {
  if (action.type === FAQ) {
    return action.contentFaq;
  }
  return state;
};
